import { render, staticRenderFns } from "./deliveryTime.vue?vue&type=template&id=2be39a6a&scoped=true"
import script from "./deliveryTime.vue?vue&type=script&lang=js"
export * from "./deliveryTime.vue?vue&type=script&lang=js"
import style0 from "./deliveryTime.vue?vue&type=style&index=0&id=2be39a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be39a6a",
  null
  
)

export default component.exports